import loyaltyEn from './en/en.json'
import loyaltyAr from './ar/ar.json'
import loyaltyEs from './es/es.json'
import loyaltyDe from './de/de.json'
import loyaltyIt from './it/it.json'
import loyaltyFr from './fr/fr.json'
import loyaltyPt from './pt/pt.json'
import loyaltyEl from './el/el.json'
import loyaltyBn from './bn/bn.json'
import loyaltySr from './sr/sr.json'
import loyaltyCs from './cs/cs.json'
import loyaltyPl from './pl/pl.json'
import loyaltyHu from './hu/hu.json'
import loyaltySk from './sk/sk.json'
import loyaltyRo from './ro/ro.json'
import loyaltyBg from './bg/bg.json'
import loyaltyMk from './mk/mk.json'
import loyaltySq from './sq/sq.json'

const LoyaltyMessages = {
  en: { loyalty: { ...loyaltyEn } },
  ar: { loyalty: { ...loyaltyAr } },
  es: { loyalty: { ...loyaltyEs } },
  de: { loyalty: { ...loyaltyDe } },
  it: { loyalty: { ...loyaltyIt } },
  fr: { loyalty: { ...loyaltyFr } },
  pt: { loyalty: { ...loyaltyPt } },
  el: { loyalty: { ...loyaltyEl } },
  bn: { loyalty: { ...loyaltyBn } },
  sr: { loyalty: { ...loyaltySr } },
  cs: { loyalty: { ...loyaltyCs } },
  pl: { loyalty: { ...loyaltyPl } },
  hu: { loyalty: { ...loyaltyHu } },
  sk: { loyalty: { ...loyaltySk } },
  ro: { loyalty: { ...loyaltyRo } },
  bg: { loyalty: { ...loyaltyBg } },
  mk: { loyalty: { ...loyaltyMk } },
  sq: { loyalty: { ...loyaltySq } },
}

export default LoyaltyMessages
